import React from 'react';
import Popup from 'components/popups/popup';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {hideTips} from "../../actions/tips";
import PropTypes from "prop-types";

class PopupInPersonAptTips extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    _hide(manual=true, delay=250) {
        super._hide(manual, delay);
        this.props.hideTips();
    }

    title() {
        if (this.props && this.props.ADO && this.props.ADO.user) {
            return 'Hello ' + this.props.ADO.user.first_name + '!';
        }else{
            return 'Hello!';
        }
    }

    subtitle() {
        return 'Based on the information you provided, your item qualifies for our premium in-person appointment option. Choose how you\'d like to deliver your item to us:';
    }

    content() {
        return (
            <div>
                <h6>In-Person CIRCA Appointment</h6>
                <div className="popup-answer">
                    Schedule an in-person appointment with our trusted partner, CIRCA, to hand deliver your item.
                    During the appointment, you will meet privately with a CIRCA expert who will evaluate your
                    item and walk you through every step of the selling process.
                </div>

                { this.props.showSchedulePickup ?
                    <React.Fragment>
                        <h6>Secure Shipping</h6>
                        <div className="popup-answer">
                            Ship your item to Worthy&apos;s office in NYC using complimentary insured FedEx shipping.
                            Schedule a FedEx pick-up right from your home or drop your item off at any staffed FedEx location near you.
                        </div>
                    </React.Fragment>
                    : null
                }
            </div>
        );
    }
}

const mapStateToProps = ({ ADO }) => {
    return {
        ADO
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ hideTips }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupInPersonAptTips);
